import { CtaButtonSlice } from '@monofront/slice-machine/prismicio-types';
import { CtaButtonDefault } from './OneCta';
import { CtaButtonTwoCta } from './TwoCta';
import DeprecatedCtaButton from './DeprecatedCtaButton';

export const CtaButton = (props: CtaButtonSlice) => {
  if (props.variation === 'default') {
    return <DeprecatedCtaButton prismicContent={props} />;
  }

  if (props.variation === 'oneCta') {
    return <CtaButtonDefault {...props} />;
  }

  if (props.variation === 'twoCta') {
    return <CtaButtonTwoCta {...props} />;
  }

  // @ts-expect-error safeguard missing Prismic definition
  throw new Error(`Unknown variation for CtaButton: ${props.variation}`);
};

export default CtaButton;
